import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StepperState {
  activeStep: number;
  completedSteps: Record<number, number>;
  skippedSteps: Record<number, number>;
}

const initialState: StepperState = {
  activeStep: 0,
  completedSteps: {},
  skippedSteps: {},
};

const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    nextStep(state) {
      if (state.activeStep < Number.MAX_SAFE_INTEGER) {
        state.activeStep += 1;
      }
    },
    prevStep(state) {
      if (state.activeStep > 0) {
        state.activeStep -= 1;
      }
    },
    resetStepper(state) {
      state.activeStep = 0;
      state.completedSteps = {};
      state.skippedSteps = {};
    },
    skipStep(state, action: PayloadAction<{ key: number, value: number }>) {
      if (!state.skippedSteps[action.payload.key]) {
        state.skippedSteps[action.payload.key] = action.payload.value;
      }
    },
    unskipStep(state, action: PayloadAction<number>) {
      if (state.skippedSteps[action.payload]) {
        delete state.skippedSteps[action.payload];
      }
    },
    setCompletedStep(state, action: PayloadAction<{ key: number, value: number }>) {
      state.completedSteps[action.payload.key] = action.payload.value;
    },
  },
});

export const {
  nextStep,
  prevStep,
  resetStepper,
  skipStep,
  unskipStep,
  setCompletedStep, // <-- add this export
} = stepperSlice.actions;

export default stepperSlice.reducer;
